import { NetworkService, ConnectionStatus } from "./services/network.service";
import { Injectable, OnInit, Directive } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { async, from, Observable, of, throwError } from "rxjs";
import { map, catchError, tap } from "rxjs/operators";
import { Global } from "../global";
import { Storage } from "@ionic/storage-angular";
import { OfflineManagerService } from "./services/offline-manager.service";
import { FileService } from "./services/file.service";
import * as CryptoJS from "crypto-js";

const API_STORAGE_KEY = "specialkey";

const httpOptions = {
  headers: new HttpHeaders({
    "Accept-Encoding": "gzip",
  }),
};

@Injectable({
  providedIn: "root",
})
export class AppService implements OnInit {
  secret: string = "2DB0388F-5E28-4B4F-B9E2-6A281EF50253";
  constructor(
    private http: HttpClient,
    public globals: Global,
    private storage: Storage,
    private networkService: NetworkService,
    private offlineManager: OfflineManagerService,
    private fileService: FileService
  ) { }

  getBaseUrlServices() {
    return sessionStorage.getItem("baseUrlServices");
  }

  private extractData(res: Response) {
    let body = res;
    return body || {};
  }
  ngOnInit() { }

  encrypt(data, key) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
  }

  decrypt(data, key) {
    let bytes = CryptoJS.AES.decrypt(data, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  // Save result of API requests
  private setLocalData(key: string, data: any): void {
    data = this.encrypt(data, this.secret);
    this.storage.create().then(() => {
      this.storage.set(`${API_STORAGE_KEY}-${key}`, data);
    });
  }

  // Get cached API result
  private getLocalData(key) {
    return this.storage.get(`${API_STORAGE_KEY}-${key}`).then((data) => {
      return this.decrypt(data ? data : "", this.secret);
    });
  }

  GUID() {
    function id() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      id() +
      id() +
      "-" +
      id() +
      "-" +
      id() +
      "-" +
      id() +
      "-" +
      id() +
      id() +
      id()
    );
  }

  UploadPost(files: any) {
  
  return this.http
    .post(this.getBaseUrlServices() + "UploadPost", files, {
      responseType: "text",
    })
    .pipe(
      tap((res) => {
        console.log("UploadPost raw response:", res);
      }),
      catchError((e) => {
        console.error("UploadPost error:", e);
        return throwError(() => e);
      })
    );
}

  UnityTest(Content: any) {
    return this.http.post(this.globals.XRSUnity + "Test", Content).pipe(
      tap((res) => {
        try {
          const returnData = JSON.parse(res.toString());
        } catch (e) {
          console.log(e);
        }
      }),
      catchError((e) => {
        throw new Error(e);
      })
    );
  }

  GetContentList(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSContentList", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetContentListDetails(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSContentListDetails", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQuestionListDetails(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSQuestionListDetails", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetContentDetail(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSContentDetail", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetContentDetail(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSContentDetail", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetContentByGUID(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetContentByGUID", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQuestionByGUIDCB(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetQuestionByGUIDCB", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateContent(Content: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateContent", Content)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetUsers(): Observable<any> {
    console.log(
      "hier gaan ons alweer " + this.getBaseUrlServices() + "UnityGetAllUsers"
    );
    return this.http
      .get(this.getBaseUrlServices() + "UnityGetAllUsers")
      .pipe(map(this.extractData));
  }

  SaveRegistration(registration: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SaveXRSRegistration", registration)
      .pipe(
        tap((res) => {
          try {
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonListForSubscriptions(LessonFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetLessonListForSubscriptions",
        LessonFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonList(LessonFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetCourseList", LessonFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonIndex(LessonFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetLessonIndex", LessonFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonDetail(Lesson_GUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetLessonDetail", Lesson_GUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetLessonInactive(Lesson_GUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSLessonInactive", Lesson_GUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetUserInactive(User_GUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSUserInactive", User_GUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonSiteList(SiteAssignment: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSLessonSiteList", SiteAssignment)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetLessonSites(SiteAssignment: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSLessonSites", SiteAssignment)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetScheduledUserTraining(ScheduledUserTraining: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetScheduledUserTraining",
        ScheduledUserTraining
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetScheduledLMSUsers(ScheduledLMSUsers: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetScheduledLMSUsers",
        ScheduledLMSUsers
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  AssignListOfLMSScheduledUsers(AssignListOfLMSScheduledUsers: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "AssignXRSListOfLMSScheduledUsers",
        AssignListOfLMSScheduledUsers
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetPublishedLessonList(LessonFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetPublishedLessonList", LessonFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetPublishedLessonDetail(Lesson_GUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetLessonDetail", Lesson_GUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetCourseDetail(Lesson_GUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetCourseDetail", Lesson_GUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateLesson(LessonDetail: any) {
      return this.http
          .post(
              this.getBaseUrlServices() + "UpdateLesson",
              LessonDetail,
              { responseType: "text" }
          )
          .pipe(
              map((res: string) => {
                  try {
                      return JSON.parse(res);
                  } catch {
                      return res;
                  }
              }),
              catchError((error) => {
                  return throwError(() => error);
              })
          );
  }

  ExportLesson(LessonDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "ExportXRSLesson", LessonDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  ImportLesson(LessonDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "ImportXRSLesson", LessonDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetMediaList(mediaFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSContentMediaList", mediaFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetMediaDetail(mediaSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSMediaDetail", mediaSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateMedia(MediaSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSMedia", MediaSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetLessonPeople(UserList: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSLessonPeople", UserList)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonPeople(UserList: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSLessonPeople", UserList)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  //assign lessons to user
  SetLessonsPerson(LessonList: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSPersonLessons", LessonList)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  //assign lessons to user
  GetLessonsPerson(LessonList: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSPersonLessons", LessonList)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetNotificationList(LessonList: any): Observable<any> {
    return this.http
      .post(this.getBaseUrlServices() + "GetNotificationList", LessonList)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetIncompleteLessonList(LessonList: any): Observable<any> {
    return this.http
      .post(this.getBaseUrlServices() + "GetIncompleteLessonList", LessonList)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetTutorialVideoList(): Observable<any> {
    return this.http.get(this.getBaseUrlServices() + "GetTutorialVideos").pipe(
      tap((res) => {
        try {
          const returnData = JSON.parse(res.toString());
        } catch (e) {
          console.log(e);
        }
      }),
      catchError((e) => {
        throw new Error(e);
      })
    );
  }

  //assign multiple lessons to multiple users
  SetLessonsAndPeople(PeopleLessonlists: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "SetLessonsAndPeople",
        PeopleLessonlists
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UnityGetAzureStoragePrograms(UnityGetAzureStoragePrograms: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UnityGetAzureStoragePrograms", UnityGetAzureStoragePrograms)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetLessonJobTitle(JobtitleLessons: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSLessonJobTitle", JobtitleLessons)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLessonJobTitle(JobtitleLessons: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSLessonJobTitle", JobtitleLessons)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQualificationTypeList() {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSQualificationTypeList", "")
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  ////This is only for testing purposes for opening ofline documents
  async GetDownloadFile() {
    let filename =
      "http://localhost/WebLMS/Resources/LMS/Glencore/Kroondal/Conveyors/videos/English/Acc/Post-Lifting of equipment using roof bolts for anchoring lifting equipment.mp4";
    filename = filename.replace(/\//g, "-");
    filename = filename.replace(":", "-");

    const src = (await this.fileService.readFile("STSContent", filename))
      .success;
  }

  GetPeopleList(peopleFilter: any) {
    if (
      this.networkService.getCurrentNetworkStatus() === ConnectionStatus.Offline
    ) {
      // Return the cached data from Storage
      this.GetDownloadFile();

      return from(this.getLocalData("Users"));
    } else {
      return this.http
        .post(this.getBaseUrlServices() + "GetXRSPeopleList", peopleFilter)
        .pipe(
          tap((res) => {
            try {
              const returnData = JSON.parse(res.toString());
              this.setLocalData("Users", res);

              this.fileService.deleteAllFiles("STSContent");
              this.fileService.downloadFile(
                "STSContent",
                "https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_1920_18MG.mp4"
              );
            } catch (e) {
              console.log(e);
            }
          }),
          catchError((e) => {
            throw new Error(e);
          })
        );
    }
  }

  GetPersonDetail(peopleSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSPersonDetail", peopleSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetCommunicationDistribusionList(distributionListSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSCommunicationDistribusionList",
        distributionListSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetDepartmentList(departmentFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSDepartmentList",
        departmentFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateDepartment(DepartmentDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSDepartment", DepartmentDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetDepartmentDetail(departmentSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSDepartmentDetail",
        departmentSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteDepartment(DepartmentDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSDepartment", DepartmentDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetGenderList() {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSGenderList", "")
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLanguageList(languageFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSLanguageList", languageFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetMaritalStatusList(maritalStatusListFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSMaritalStatusList",
        maritalStatusListFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSiteList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetSites", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetClientLanding(Client_GUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSClientLanding", Client_GUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVendorList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVendorList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CreatePerson(PersonDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "CreateXRSPerson", PersonDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CreatePersonSimplified(PersonSimplifiedDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "CreateXRSPersonSimplified",
        PersonSimplifiedDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdatePerson(PersonDetail: any) {
    if (
      this.networkService.getCurrentNetworkStatus() === ConnectionStatus.Offline
    ) {
      var object = {};
      PersonDetail.forEach((value, key) => (object[key] = value));
      return from(
        this.offlineManager.storeRequest(
          this.getBaseUrlServices() + "UpdateXRSPerson",
          "POST",
          object
        )
      );
    } else {
      return this.http
        .post(this.getBaseUrlServices() + "UpdateXRSPerson", PersonDetail)
        .pipe(
          tap((res) => {
            try {
              const returnData = JSON.parse(res.toString());
            } catch (e) {
              console.log(e);
            }
          }),
          catchError((e) => {
            throw new Error(e);
          })
        );
    }
  }

  UpdatePersonSimplified(PersonSimplifiedDetail: any) {
    if (
      this.networkService.getCurrentNetworkStatus() === ConnectionStatus.Offline
    ) {
      var object = {};
      PersonSimplifiedDetail.forEach((value, key) => (object[key] = value));
      return from(
        this.offlineManager.storeRequest(
          this.getBaseUrlServices() + "UpdateXRSPerson",
          "POST",
          object
        )
      );
    } else {
      return this.http
        .post(
          this.getBaseUrlServices() + "UpdateXRSPersonSimplified",
          PersonSimplifiedDetail
        )
        .pipe(
          tap((res) => {
            try {
              const returnData = JSON.parse(res.toString());
            } catch (e) {
              console.log(e);
            }
          }),
          catchError((e) => {
            throw new Error(e);
          })
        );
    }
  }

  GetCourseList(qualificationFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSQualificationList",
        qualificationFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQualificationDetail(qualificationSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSQualificationDetail",
        qualificationSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SaveQualification(QualificationDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "SaveXRSQualification",
        QualificationDetail
      )
      .pipe(
        tap((res) => {
          try {
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLicenseList(licenseFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSLicenseList", licenseFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSiteLicensingParameters(licenseFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSSiteLicenseParameters",
        licenseFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetClientInvoice(licenseFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSSiteSubscriptionInvoice",
        licenseFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetLicenseDetail(licenseSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSLicenseDetail", licenseSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateLicense(LicenseDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSLicense", LicenseDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CreateLicenseTransactionOrder(LicenseDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "CreateLicenseTransactionOrder",
        LicenseDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSubscriptionList(subscriptionFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSSiteSubscriptionList",
        subscriptionFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSubscriptionTransactionList(subscriptionFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSSiteSubscriptionTransactionList",
        subscriptionFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSubscriptionDetail(subscriptionSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSSiteSubscriptionDetail",
        subscriptionSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateSubscription(SubscriptionDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSSiteSubscription",
        SubscriptionDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetPricePlanList(pricePlanFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSPricePlanList", pricePlanFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetAvailablePricePlanList(pricePlanFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSAvailablePricePlans",
        pricePlanFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetPricePlanDetail(pricePlanSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSPricePlanDetail",
        pricePlanSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdatePricePlan(PricePlanDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSPricePlan", PricePlanDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetProcedureDetail(ProcedureSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSProcedureDetail",
        ProcedureSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetProceduresByReferencePage(ProcedureReferencePage: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSProceduresByReferenancePage",
        ProcedureReferencePage
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  updateUserPassword(updateUserPassword: any) {
    return this.http
      .post(this.getBaseUrlServices() + "updateXRSpassword", updateUserPassword)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  checkFirstLoginStatus(
    userToken: string,
    userGUID: string
  ): Observable<boolean> {
    const requestBody = {
      User_Token: userToken,
      User_GUID: userGUID,
    };

    return this.http
      .post<boolean>(
        this.getBaseUrlServices() + "checkFirstLoginStatus",
        requestBody
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateProcedure(ProcedureDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSProcedure", ProcedureDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetProcedureList(ProcedureFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSProcedureList", ProcedureFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetProcedureSignedList(ProcedureFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSProcedureSignedList",
        ProcedureFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  testXRSCore(json: any) {
    return this.http.post(this.globals.XRSCore + "testXRSCore", json).pipe(
      tap((res) => {
        try {
          const returnData = JSON.parse(res.toString());
        } catch (e) {
          console.log(e);
        }
      }),
      catchError((e) => {
        throw new Error(e);
      })
    );
  }

  GetRegionsList(regionsFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSRegionsList", regionsFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetXRSRegionsMoreDetail(regionsSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSRegionsMoreDetail",
        regionsSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetRegionsDetail(regionsSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSRegionsDetail", regionsSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateRegions(RegionsDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSRegions", RegionsDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteRegion(RegionDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSRegions", RegionDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetCountryList(countryFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSCountryList", countryFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVillageList(villageFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVillageList", villageFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetAuthorityLevelList(authorityFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSAuthorityLevelList",
        authorityFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVillageDetail(villageSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVillageDetail", villageSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateVillage(VillageDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSVillage", VillageDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteVillage(VillageDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSVillage", VillageDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetJobTitleForList(jobTitleFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSJobTitleList", jobTitleFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetJobTitleListWithFilter(jobTitleFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSJobTitleList", jobTitleFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetJobTitleList() {
    return this.http.post(this.getBaseUrlServices() + "GetJobTitles", "").pipe(
      tap((res) => {
        try {
          const returnData = JSON.parse(res.toString());
        } catch (e) {
          console.log(e);
        }
      }),
      catchError((e) => {
        throw new Error(e);
      })
    );
  }

  SetJobTitleDetail(jobTitleSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "SetXRSJobTitleDetail",
        jobTitleSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetJobTitleDetail(jobTitleSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSJobTitleDetail",
        jobTitleSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateJobTitle(JobTitleDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSJobTitle", JobTitleDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteJobTitle(JobTitleDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSJobTitle", JobTitleDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSiteListWithFilter(siteFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSiteList", siteFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetRoleListWithFilter(roleFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSRoleList", roleFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSiteDetailWithSelectedSite(siteSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSiteDetail", siteSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateSite(SiteDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSSite", SiteDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteSite(SiteDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSSite", SiteDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  //
  GetWorkScheduleListWithFilter(workScheduleFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSWorkScheduleList",
        workScheduleFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetWorkScheduleDetailWithSelectedWorkSchedule(workScheduleSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSWorkScheduleDetail",
        workScheduleSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetRaceListWithFilter(raceFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSRaceList", raceFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetRaceList(raceFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSMineRentalTypeList", raceFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetRaceDetail(raceSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSRaceDetail", raceSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateRace(RaceDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSRace", RaceDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteRace(RaceDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSRace", RaceDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetFormList(formFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSFormList", formFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetFormDetail(formSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSFormDetail", formSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateForm(FormDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSForm", FormDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  //1
  GetMineRentalTypeList(mineRentalTypeFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSMineRentalTypeList",
        mineRentalTypeFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetMineRentalTypeDetail(mineRentalTypeSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSMineRentalTypeDetail",
        mineRentalTypeSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateMineRentalType(MineRentalTypeDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSMineRentalType",
        MineRentalTypeDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteMineRentalType(MineRentalTypeDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "DeleteXRSMineRentalType",
        MineRentalTypeDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetHousingStatusListWithFilter(housingStatusFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSHousingStatusList",
        housingStatusFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetHousingStatusList(housingStatusFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSHousingStatusList",
        housingStatusFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetHousingStatusDetail(housingStatusSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSHousingStatusDetail",
        housingStatusSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateHousingStatus(HousingStatusDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSHousingStatus",
        HousingStatusDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteHousingStatus(HousingStatusDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "DeleteXRSHousingStatus",
        HousingStatusDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  //2
  GetReportList(reportFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSReportList", reportFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetReportDetail(reportSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSReportDetail", reportSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }
  GetSiteDetail(siteSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSiteMoreDetail", siteSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateSiteDetail(SiteDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSSiteDetail", SiteDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetTrainingQualificationList(UserDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetTrainingQualificationList",
        UserDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetTrainingLessonList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetTrainingLessonList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetContractorList(Contractor_Detail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSContractorList",
        Contractor_Detail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetContractorDetail(contractorSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSContractorDetail",
        contractorSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVisitorList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVisitorList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVisitorDetail(VisitorSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVisitorDetail", VisitorSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateVisitor(VisitorSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSVisitor", VisitorSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSOWList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSOWList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSOWDetail(SOWSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSOWDetail", SOWSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateSOW(SOWSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSSOW", SOWSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SubmitSOW(SOWSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SubmitXRSSOW", SOWSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SetAuhorizationStatus(SOWSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SetXRSAuhorizationStatus", SOWSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVehicleList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVehicleList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetVehicleDetail(VehicleSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSVehicleDetail", VehicleSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateVehicle(VehicleSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSVehicle", VehicleSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetPeopleGroupsList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSPeopleGroupsList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetPeopleGroupsDetail(PeopleGroupsSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSPeopleGroupsDetail",
        PeopleGroupsSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdatePeopleGroups(PeopleGroupsSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSPeopleGroups",
        PeopleGroupsSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetChemicalList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSChemicalList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetChemicalDetail(SOWSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSChemicalDetail", SOWSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetEquipmentList(UserGUID: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSEquipmentList", UserGUID)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetEquipmentDetail(SOWSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSEquipmentDetail", SOWSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SaveEquipment(EquipmentDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SaveXRSEquipment", EquipmentDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SaveContractor(ContractorDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "SaveXRSContractor", ContractorDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }
  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  GetTitleList(titleFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSTitleList", titleFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetTitleDetail(titleSelected: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSTitleDetail", titleSelected)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateTitle(TitleDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSTitle", TitleDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteTitle(TitleDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSTitle", TitleDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetWorkScheduleList(workScheduleFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSWorkScheduleList",
        workScheduleFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetWorkScheduleDetail(workScheduleSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSWorkScheduleDetail",
        workScheduleSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateWorkSchedule(WorkScheduleDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSWorkSchedule",
        WorkScheduleDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteWorkSchedule(WorkScheduleDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "DeleteXRSWorkSchedule",
        WorkScheduleDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetWorkAreaList(workAreaFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSWorkAreaList", workAreaFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQuestionDetails(questionFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSQuestionDetails", questionFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQuestionByGUID(questionFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetQuestionByGUID", questionFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetInductionLessonList(inductionLessonFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetShortLessonList",
        inductionLessonFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetWorkAreaDetail(workAreaSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSWorkAreaDetail",
        workAreaSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateWorkArea(WorkAreaDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSWorkArea", WorkAreaDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  DeleteWorkArea(WorkAreaDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "DeleteXRSWorkArea", WorkAreaDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetQualificationsLessonsPerJobTile(JobTitleDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetQualificationsLessonsPerJobTile",
        JobTitleDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SaveDistributionList(DistributionListDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "SaveXRSDistributionList",
        DistributionListDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetDistributionListDetail(distributionListSelected: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSDistributionListDetail",
        distributionListSelected
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetRegionNameListFilter(regionNameFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSRegionNameList",
        regionNameFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetCountryCodeFilter(countryCodeFilter: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSCountryCodeList",
        countryCodeFilter
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetOrPopulateUserSequence(LessonDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetOrPopulateUserSequence",
        LessonDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateUserSequencerRecord(UpdateUserSequencerRecordDetail: any) {
    if (
      this.networkService.getCurrentNetworkStatus() === ConnectionStatus.Offline
    ) {
      var object = {};
      UpdateUserSequencerRecordDetail.forEach(
        (value, key) => (object[key] = value)
      );
      return from(
        this.offlineManager.storeRequest(
          this.getBaseUrlServices() + "UpdateXRSUserSeqeunceRecordCompleted",
          "POST",
          object
        )
      );
    } else {
      return this.http
        .post(
          this.getBaseUrlServices() + "UpdateXRSUserSeqeunceRecordCompleted",
          UpdateUserSequencerRecordDetail
        )
        .pipe(
          tap((res) => {
            try {
              const returnData = res.toString();
            } catch (e) {
              console.log(e);
            }
          }),
          catchError((e) => {
            throw new Error(e);
          })
        );
    }
  }

  UpdateAssessmentSessionDetail(QuestionDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSAssessmentSessionDetail",
        QuestionDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CalculateUserLessonScore(SessionDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "CalculateUserLessonScore",
        SessionDetail
      )
      .pipe(
        tap(async (res) => {
          try {
            const returnData = await JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  FinishSessionAndGenerateReport(SessionDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "FinishSessionAndGenerateReport",
        SessionDetail
      )
      .pipe(
        tap(async (res) => {
          try {
            const returnData = await JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateProceduresAccepted(ProcedureDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateProceduresAccepted",
        ProcedureDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetUsersByEmail(GetUsersByEmailRecordDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetUsersByEmail",
        GetUsersByEmailRecordDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = res.toString();
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetUserBusinessPartnerListWithFilter(BPFilter: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetUserBusinessPartners", BPFilter)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetSceneSummaryDetail(SSDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSceneSummaryDetail", SSDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetTrainingImages(IDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSTrainingImages", IDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  ConnectTTReceiver() {
    
    return this.http
      .get(this.globals.XRSClickerBaseURL + "ConnectReceiver", {
        responseType: "text",
      })
      .pipe(
        tap((res) => {
          try {
            const returnData = res;
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetClickerResponses(CDetail: any) {
    return this.http
      .get(
        this.globals.XRSClickerBaseURL +
        "GetResponses/" +
        CDetail.get("noOfOptions") +
        "/" +
        CDetail.get("noOfCorrectOptions"),
        { responseType: "text" }
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdatePersonClickerCode(ClickerDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "UpdateXRSPersonClickerCode",
        ClickerDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  UpdateUserSiteDetails(SiteDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "UpdateXRSUserSiteDetails", SiteDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CheckUserFailedQuestionPreviously(questionData: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "CheckXRSUserFailedQuestionPreviously",
        questionData
      )
      .pipe(
        tap((resq) => {
          try {
            const returnData = JSON.parse(resq.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetUserLessonsContent(UserData: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetUserLessonsContent", UserData)
      .pipe(
        tap((resq) => {
          try {
            const returnData = JSON.parse(resq.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetXRSOpenSessionsList(SessionDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSSessionsToEnd", SessionDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetXRSSiteAssignmentUsersList(SiteAssignmentPeopleDetail: any) {
    return this.http
      .post(
        this.getBaseUrlServices() + "GetXRSUsersAssignedSite",
        SiteAssignmentPeopleDetail
      )
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  EndXRSTrainingSession(SessionDetail: any) {
    return this.http
      .post(this.getBaseUrlServices() + "EndXRSTrainingSession", SessionDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  ImportPeople(PeopleListDetail: any) {
    
    return this.http
      .post(this.getBaseUrlServices() + "ImportXRSPeople", PeopleListDetail)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  login(credentials: any) {
    return this.http
      .post(this.globals.XRSBackendURL + "login", credentials)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  SAM_Login(credentials: any) {
    return this.http
      .post(this.globals.XRSBackendURL + "SAM_Login", credentials)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  GetGroupUserIdentificationType() {
    return this.http
      .post(this.getBaseUrlServices() + "GetXRSGroupUserIdentificationType", "")
      .pipe(
        tap((res) => {
          try {
            const returnData = res;
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CreateGroupWithUsers(groupData: any) {
    return this.http
      .post(this.getBaseUrlServices() + "CreateGroupWithUsers", groupData)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }

  CreateGroupFromPrevious(groupData: any) {
    return this.http
      .post(this.getBaseUrlServices() + "CreateGroupFromPrevious", groupData)
      .pipe(
        tap((res) => {
          try {
            const returnData = JSON.parse(res.toString());
          } catch (e) {
            console.log(e);
          }
        }),
        catchError((e) => {
          throw new Error(e);
        })
      );
  }
}
